import { Group, Select, SelectProps } from '@mantine/core';
import {
  IconAlignLeft,
  IconBlockquote,
  IconCode,
  IconH1,
  IconH2,
  IconH3,
  IconList,
  IconListCheck,
  IconListNumbers
} from '@tabler/icons-react';
import {
  formatBulletList,
  formatCheckList,
  formatCode,
  formatHeading,
  formatNumberedList,
  formatParagraph,
  formatQuote,
} from './utils';

const iconProps = {
  stroke: 1.5,
  color: 'currentColor',
  opacity: 0.6,
  size: 18,
};

const icons: Record<string, React.ReactNode> = {
  paragraph: <IconAlignLeft {...iconProps} />,
  h1: <IconH1 {...iconProps} />,
  h2: <IconH2 {...iconProps} />,
  h3: <IconH3 {...iconProps} />,
  bullet: <IconList {...iconProps} />,
  number: <IconListNumbers {...iconProps} />,
  check: <IconListCheck {...iconProps} />,
  quote: <IconBlockquote {...iconProps} />,
  code: <IconCode {...iconProps} />,
};

const renderSelectOption: SelectProps['renderOption'] = ({ option, checked }) => (
  <Group flex="1" gap="xs">
    {icons[option.value]}
    {option.label}
  </Group>
);

export function ParagraphStyleSelect({ editor, blockType }) {
  return (
    <Select
      w={160}
      style={{ flexGrow: 1 }}
      variant="unstyled"
      placeholder="Select text align"
      data={[
        { value: 'paragraph', label: 'Normal' },
        { value: 'h1', label: 'Heading 1' },
        { value: 'h2', label: 'Heading 2' },
        { value: 'h3', label: 'Heading 3' },
        { value: 'bullet', label: 'Bulleted List' },
        { value: 'number', label: 'Numbered List' },
        { value: 'check', label: 'Checklist' },
        { value: 'quote', label: 'Quote' },
        { value: 'code', label: 'Code Block' },
      ]}
      value={blockType}
      renderOption={renderSelectOption}
      maxDropdownHeight={400}
      onChange={(value) => {
        if (value === 'paragraph') {
          formatParagraph(editor);
        } else if (value === 'h1') {
          formatHeading(editor, blockType, 'h1');
        } else if (value === 'h2') {
          formatHeading(editor, blockType, 'h2');
        } else if (value === 'h3') {
          formatHeading(editor, blockType, 'h3');
        } else if (value === 'bullet') {
          formatBulletList(editor, blockType);
        } else if (value === 'number') {
          formatNumberedList(editor, blockType);
        } else if (value === 'check') {
          formatCheckList(editor, blockType);
        } else if (value === 'quote') {
          formatQuote(editor, blockType);
        } else if (value === 'code') {
          formatCode(editor, blockType);
        }
      }}
    />
  );
}
